// Serif font preference — toggled from Utility > Appearance.
// Persists to localStorage and applies via the --font-serif CSS variable
// (consumed by Tailwind's `font-serif` utility).

const STORAGE_KEY = 'cts-erp-serif-font';

export const SERIF_FONTS = {
  'source-serif-4': {
    label: 'Source Serif 4',
    subtitle: 'Google Fonts — modern editorial',
    stack: '"Source Serif 4", "Source Serif Pro", Georgia, Cambria, serif',
  },
  'times': {
    label: 'Times New Roman',
    subtitle: 'Classic system serif',
    stack: '"Times New Roman", Times, Georgia, Cambria, serif',
  },
};

export const DEFAULT_SERIF = 'source-serif-4';

export function getSerifFont() {
  if (typeof window === 'undefined') return DEFAULT_SERIF;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return SERIF_FONTS[stored] ? stored : DEFAULT_SERIF;
}

export function applySerifFont(key) {
  const choice = SERIF_FONTS[key] ? key : DEFAULT_SERIF;
  document.documentElement.style.setProperty('--font-serif', SERIF_FONTS[choice].stack);
  return choice;
}

export function setSerifFont(key) {
  const choice = SERIF_FONTS[key] ? key : DEFAULT_SERIF;
  window.localStorage.setItem(STORAGE_KEY, choice);
  applySerifFont(choice);
  return choice;
}
